const ccCurrencyCodes = {
  US: 'USD',
  BB: 'BBD',
  KY: 'KYD',
  CA: 'CAD',
  AU: 'AUD',
  NZ: 'NZD',
  GB: 'GBP',
  ES: 'USD',
  IT: 'USD',
  IN: 'USD',
  PH: 'USD',
  VN: 'USD',
  GR: 'USD',
}

const NATIVE_CURRENCY_COUNTRIES = ['AU', 'NZ', 'CA', 'GB']

const currencyFormat = ({price, country}) => {
  if (!country) country = 'US'
  const locale = NATIVE_CURRENCY_COUNTRIES.includes(country)
    ? `en-${country}`
    : 'en-US'
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: ccCurrencyCodes[country] || 'USD',
  }).format(price)
}

const formatPrice = ({amount, quantity = 1, title = '', country}) => {
  if (typeof amount === 'string') return amount
  if (
    (title.includes('SEO') &&
      title !== 'SEO Keywords' &&
      title !== 'AEO & SEO PowerBoost' &&
      title !== 'AEO & SEO') ||
    title.includes('Thryv Leads')
  ) {
    quantity = 1
  }

  if (amount === undefined) {
    return ''
  }
  return currencyFormat({
    price: amount * quantity,
    country: country || 'US',
    isCcOrder: true,
  })
}

export {currencyFormat, formatPrice, ccCurrencyCodes}
